/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { Prompt } from 'react-router-dom';
import { Dialog as BlueprintDialog, Button, Classes } from '@blueprintjs/core';

export const Dialog = ({ body, footer, style, ...props }) => { // Why does this exist?
	// export const Dialog = ({ title, icon, body, onClose, style, footer }) => { 
	return (
		<BlueprintDialog
			css={style} // style is different from css
			// icon={icon} // in props
			// onClose={onClose} // in props
			// title={title} // in props
			// footer={footer} // doesn't exist
			// body={body} // doesn't exist
			isOpen // ??? // why always open
			// autoFocus // defaults to true
			// canEscapeKeyClose // defaults to true
			// canOutsideClickClose // defaults to true
			// enforceFocus // defaults to true
			// usePortal // defaults to true
			{...props}
		>
			{body}
			{footer}
			{/* body and footer could just be children? */}
		</BlueprintDialog>
	);
}

export const RouteLeavingGuard = ({ when, shouldBlockNavigation, navigate, title, text, icon }) => {
	const [isModalVisible, setModalVisible] = useState(false);
	const [lastLocation, setLastLocation] = useState(null);
	const [isNavigationConfirmed, setIsNavigationConfirmed] = useState(false);

	const showModal = (location) => {
		setModalVisible(true);
		setLastLocation(location);
	}

	const closeModal = () => {
		setModalVisible(false);
	}

	const handleBlockedNavigation = useCallback((nextLocation) => {
		if (!isNavigationConfirmed && shouldBlockNavigation(nextLocation)) {
			showModal(nextLocation);
			return false;
		}
		return true;
	}, [isNavigationConfirmed, shouldBlockNavigation]);

	const handleConfirmNavigationClick = useCallback(() => {
		setModalVisible(false);
		if (lastLocation) {
			setIsNavigationConfirmed(true);
		}
	}, [lastLocation]);

	useEffect(() => {
		if (isNavigationConfirmed) {
			navigate(lastLocation.pathname);
		}
	}, [isNavigationConfirmed, lastLocation, navigate]);

	return (
		<Fragment>
			<Prompt
				when={when}
				message={handleBlockedNavigation}
			/>
			{/* {isModalVisible && */}
			<BlueprintDialog
				isOpen={isModalVisible}
				onClose={closeModal}
				title={title}
				css={styles.Dialog}
				icon={icon}
				children={
					<Fragment>
						<div className={Classes.DIALOG_BODY}>
							<p>{text}</p>
						</div>
						<div className={Classes.DIALOG_FOOTER} >
							<Button minimal onClick={closeModal}>Cancel</Button>
							<Button outlined onClick={handleConfirmNavigationClick} intent="primary">Continue</Button>
						</div>
					</Fragment>
				}
			/>
			{/* } */}
		</Fragment>
	)
}

const styles = {
	Dialog: css`
	.${Classes.BUTTON}{ 
		margin-left: 5px; 
	}
	.${Classes.DIALOG_FOOTER}{ 
		text-align: right; 
	}
`,
}
